module.exports = __webpack_public_path__ + "static/img/yiban.344cf143.png";